export default "__VITE_ASSET__BwTbUhf2__"